/**
 * Render a label
 * 
 * This is the main label used for components3. Most of the labels are incorporated into the component itself (such as input). If an independent label is needed use this component.
 * Note that you can pass in label as a props, but also as an extra value. This is to make it easier to use. Both are OK to use.
 */

import React from "react";
import styled from "styled-components";
import { injectIntl } from 'react-intl'


export const Label = styled.div`
  padding-left: 0px;
  margin-bottom:15px;
`

export default injectIntl((props) => {

  const { extra = {} } = props;
  const { label = props.label } = extra;


  if( ! label ) {
    return null
  }

  return (
    <Label className='sp-form-label'>{label ? props.intl.formatMessage({id: label}) : ''}</Label>
  );
});
